import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DropdownModule} from '../../../../../shared-components/dropdowns/dropdown/dropdown.module';
import {DatePickerModule} from '../../../../../shared-components/date-picker/date-picker.module';
import {ReservationsHttpService} from '../../../../../services/http-services/reservations/reservations-http.service';
import {FormControlErrorMessagesModule} from '../../../../../pipes/form-control-error-messages/form-control-error-messages.module';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {ReactiveFormsModule} from '@angular/forms';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {GrPagination} from '../../../../../interfaces/general-interfaces';
import {PaginationModule} from '../../../../../shared-components/pagination/pagination.module';
import {PAGES_AND_PATHS} from '../../../../../constants/pages-and-paths';
import {RouterLink} from '@angular/router';
import {Subscription} from "rxjs";
import {NotificationsHelperService} from "../../../../../services/helpers/notifications-helper.service";

@Component({
  selector: 'gr-reservations-tab',
  standalone: true,
  imports: [
    DropdownModule,
    DatePickerModule,
    FormControlErrorMessagesModule,
    NgxMaterialTimepickerModule,
    ReactiveFormsModule,
    DatePipe,
    NgIf,
    PaginationModule,
    NgForOf,
    RouterLink
  ],
  templateUrl: './reservations-tab.component.html',
  providers: [DatePipe]
})
export class ReservationsTabComponent implements OnInit {
  reservations: any = [];
  reservationPagination: GrPagination | undefined;
  urlParams: {page: number, date: string | null} = {page: 1, date: null};
  currentDate: Date = new Date();
  minDate = new Date(this.currentDate.getFullYear() - 10, this.currentDate.getMonth(), this.currentDate.getDate());
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  // unreadReservationsNotificationsCountSubscripton = new Subscription();
  @Input() reservationsCount = 0;
  @Output() reservationsNotificationsCount: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    private reservationsHttpService: ReservationsHttpService,
    private datePipe: DatePipe,
    private notificationsHelperService: NotificationsHelperService
  ) {
  }

  ngOnInit(): void  {
    this.urlParams.date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.getReservations();
    this.getNotificationsReservationsCount();
    // this.unreadReservationsNotificationsCountSubscripton = this.notificationsHelperService.newReservationNotification.subscribe((res: any) => {
    //   this.reservationsCount++;
    //   this.reservationsNotificationsCount.emit(this.reservationsCount);
    // });
  }

  getNotificationsReservationsCount(): void {
    this.reservationsHttpService.getNotificaitonsUnreadCOuntReservtions().then(res => {
      console.log('getNotificationsGiftsCount', res)
      this.reservationsCount = res.unread_count;
      this.reservationsNotificationsCount.emit(this.reservationsCount);
    });
  }

  getReservations(): void {
    this.urlParams.page = (this.reservationPagination?.currentPage) ? this.reservationPagination.currentPage : 1;
    this.reservationsHttpService.getReservationsCompanies(this.urlParams).then(res => {
      this.reservations = res.data;
      this.reservationPagination = res.pagination;
    });
  }

  onPageChanged(page: any): void {
    if (this.reservationPagination) {
      this.reservationPagination.currentPage = page;
      this.getReservations();
    }
  }
  exportReservationsPdf(): void {
    this.reservationsHttpService.getExportReservationsPdf(this.urlParams).subscribe((response: Blob) => {
      if (response.type === 'application/pdf') {
        const blobUrl = URL.createObjectURL(response);
        window.open(blobUrl, '_blank');
      } else {
        console.error('The fetched file is not a PDF');
      }
    });
  }
  exportReservationsExcel(): void {
    this.reservationsHttpService.getExportReservationsExcel(this.urlParams).subscribe((response: Blob) => {
      if (response.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const blobUrl = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'Rezervacije.xlsx';
        link.click();
        URL.revokeObjectURL(blobUrl);
      } else {
        console.error('The fetched file is not an Excel file');
      }
    });
  }
  onSelectedDate(selectedDate: any): void {
    this.urlParams.date = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.getReservations();
  }
}
